<template>
  <footer class="site-footer">
    <div class="footer-main brand-container">
      <div class="company-info">
        <router-link to="/" aria-label="Mola Games home" class="footer-logo">
          <img
            src="/brand/logo-light.svg"
            alt="Mola Games"
            width="200"
            height="70"
            loading="lazy"
          />
        </router-link>
        <p class="footer-tagline">A little break for play.</p>
        <!-- Previous positioning, retained for future use.
        <p class="footer-description">
          Building transparent, rewarding mobile games for players everywhere.
        </p>
        -->
        <p class="footer-description">
          Making everyday breaks a little brighter with mobile games full of
          personality.
        </p>
        <a href="mailto:mola@mola.games" class="contact-link"
          >Say hello <span aria-hidden="true">↗</span
          ><span class="contact-email">mola@mola.games</span></a
        >
      </div>
      <div class="footer-aside">
        <nav aria-label="Footer navigation" class="footer-links">
          <router-link to="/#games"
            >Games <span aria-hidden="true">↗</span></router-link
          >
          <router-link to="/career"
            >Career <span aria-hidden="true">↗</span></router-link
          >
          <!-- Retained for future use.
          <router-link to="/leaderboard"
            >Leaderboard <span aria-hidden="true">↗</span></router-link
          >
          -->
          <router-link to="/privacy-policy"
            >Privacy Policy <span aria-hidden="true">↗</span></router-link
          >
          <!-- Retained for future use.
          <router-link to="/wallet"
            >Your wallet <span aria-hidden="true">↗</span></router-link
          >
          -->
        </nav>
        <img
          src="@/assets/acc-ing-26.png"
          alt="Accelerator Badge"
          class="accelerator-badge"
          loading="lazy"
        />
      </div>
    </div>
    <div class="footer-bottom brand-container">
      <p>© {{ year }} Mola Games. All rights reserved.</p>
      <span>Small moments. More play.</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data: () => ({ year: new Date().getFullYear() })
};
</script>

<style scoped>
.site-footer {
  background: var(--mola-blue);
  color: var(--mola-ivory);
  padding-top: 72px;
}
.footer-main {
  display: flex;
  justify-content: space-between;
  gap: 60px;
  padding-bottom: 60px;
}
.company-info {
  max-width: 420px;
}
.footer-logo {
  display: inline-block;
}
.footer-logo img {
  display: block;
  width: 200px;
  height: auto;
}
.footer-tagline {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 24px 0 12px;
}
.footer-description {
  font-size: 0.94rem;
  line-height: 1.7;
  max-width: 320px;
}
.contact-link {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 28px;
  color: inherit;
  text-decoration: underline;
  text-decoration-color: transparent;
  text-underline-offset: 5px;
  transition: text-decoration-color var(--brand-hover-duration)
    var(--brand-feedback-easing);
  font-weight: 600;
}
.contact-email {
  width: 100%;
  font-size: 0.85rem;
  font-weight: 400;
}
.footer-aside {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  gap: 32px;
}
.footer-links {
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-width: 220px;
}
.footer-links a {
  display: flex;
  justify-content: space-between;
  gap: 40px;
  color: inherit;
  text-decoration: underline;
  text-decoration-color: transparent;
  text-underline-offset: 5px;
  transition: text-decoration-color var(--brand-hover-duration)
    var(--brand-feedback-easing);
  font-size: 0.92rem;
}
.footer-links a:hover,
.contact-link:hover {
  text-decoration-color: currentColor;
}
.footer-links a > span,
.contact-link > span[aria-hidden] {
  transition: transform var(--brand-hover-duration) var(--brand-feedback-easing);
}
.footer-links a:hover > span,
.contact-link:hover > span[aria-hidden] {
  transform: translate(2px, -2px);
}
.accelerator-badge {
  width: 160px;
  height: auto;
}
.footer-bottom {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  padding-block: 26px;
  border-top: 1px solid rgb(254 249 239 / 30%);
  font-size: 0.75rem;
}
@media (max-width: 600px) {
  .site-footer {
    padding-top: 48px;
  }
  .footer-main {
    flex-direction: column;
    gap: 40px;
    padding-bottom: 40px;
  }
  .footer-aside {
    align-items: flex-start;
  }
  .footer-links {
    width: 100%;
  }
  .footer-bottom {
    flex-direction: column;
    gap: 10px;
  }
}
</style>
